import { FunctionComponent } from "react";
import { FieldError } from "react-hook-form";


interface IDropdownWithRegisterProps {
    id: string;
    options: Record<any, any>[]
    register : Function;  
    defaultText?: string;
    error?: any;
}

const DropdownWithRegister: FunctionComponent<IDropdownWithRegisterProps> = ({
    id,
    options,
    register,
    defaultText,
    error
}) => (
    <div>
        <p className="my-2 font-semibold capitalize text-sm">{id}</p>
        <select
            id={id}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            {
            ...register(id)
            }
        >
            {
                defaultText && <option selected>{defaultText}</option>
            }
            {
                options.map(({ value, label }) => <option key={value} value={value}>{label}</option>)
            }
        </select>

        {error && <p className='text-sm text-red-600 mb-3'>{ `${error}` }</p>}
    </div>
);

export default DropdownWithRegister;